import React, { useRef, useEffect, useState, useContext } from 'react';

import { useHistory } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';

import { DialogPrintBoletimPorGrupo } from './DialogPrintBoletimPorGrupo';
import '../layout/sass/_pickListSugestoes.scss'


import '../layout/sass/_responsiveTable.scss'

import api from '../api/api';

import { FilterContext } from '../contexts/FilterContext';
import { AuthContext } from '../contexts/AuthContext';

import { PermissaoLoader } from './PermissaoLoader';
import { permissions_check } from '../utils/rotas_permissao';

export const TabelaProdutosGrupo = () => {
    const toast = useRef(null);
    const [produtos, setProdutos] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const confirmationToast = useRef(null)
    const [dt, setDt] = useState(null);
    const history = useHistory();
    const [isShowInfo, setIsShowInfo] = useState(false);
    const [msgInfo, setMsgInfo] = useState([]);
    const [showPrintBoletim, setShowPrintBoletim] = useState(false);
    const [boletimPrint, setBoletimPrint] = useState([]);
    const { user, permissoes } = useContext(AuthContext);

    const [sortable, setSortable] = useState('asc');
    const [rows, setRows] = useState(20);
    const [first, setFirst] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const { filter, setFilter } = useContext(FilterContext);
    const [showActionsColumn, setShowActionsColumn] = useState(true);
    // const [lazyParams, setLazyParams] = useState({
    //     first: 0,
    //     rows: 20,
    //     sortField: null,
    //     sortOrder: null,
    //     filters: {
    //         'nome': { value: '', matchMode: 'contains' },
    //     }
    // });



    useEffect(() => {
        const fetchProduto = async () => {
            try {
                await getProduto();

            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        }
        fetchProduto();

    }, [filter])

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">Grupo de Produtos</h2>
            </div>
            <div className="p-my-0 p-grid p-dir-rev p-col">
                <div className="p-m-2">
                    <PermissaoLoader rota="produtoGrupo" acao="criar" onClick={() => history.push('/produtoGrupocreate')} />
                </div>
                <div className="p-m-2">
                    <Button
                        label="Limpar Filtros"
                        className="p-mb-2 p-button-primary"
                        iconPos="left"
                        type="button"
                        onClick={() => setFilter({
                            first: 0,
                            rows: 20,
                            sortField: null,
                            sortOrder: null,
                            filters: {
                                'nome': { value: '', matchMode: 'contains' },
                            },

                        })}
                    />
                </div>
            </div>
        </div>

    );

    const getProduto = async (event) => {
        setIsLoading(true)
        setProdutos([])

        if (event != undefined) {
            setTimeout(() => {
                const startIndex = event.first;
                const endIndex = event.first + rows;

                setFirst(startIndex);
                // setPedras(dataSource.slice(startIndex, endIndex));
            }, 250);
        }

        try {

            if (filter.filters.nome.value == '' || filter.filters.nome == undefined) {

                if (event == undefined) {
                    const response = await api.get(`produtoGrupo?sort=nome,${sortable}`);

                    response.data.content.map(produto => {
                        setProdutos(produtos => [...produtos, produto])
                    })
                } else {
                    const response = await api.get(`produtoGrupo?page=${event.page}&sort=nome,${sortable}`);
                    response.data.content.map(produto => {
                        setProdutos(produtos => [...produtos, produto])
                    })

                }

                const respElements = await api.get(`produtoGrupo?sort=id,${sortable}`);
                setTotalRecords(respElements.data.totalElements);

            } else {

                if (event == undefined) {
                    const response = await api.get(`produtoGrupo/search?searchTerm=${filter.filters.nome.value}&sort=nome,${sortable}`);
                    response.data.content.map(produto => {
                        setProdutos(produtos => [...produtos, produto])
                    })
                } else {
                    const response = await api.get(`produtoGrupo/search?searchTerm=${filter.filters.nome.value}&page=${event.page}&sort=nome,${sortable}`);
                    response.data.content.map(produto => {
                        setProdutos(produtos => [...produtos, produto])
                    })
                }

                const respElements = await api.get(`produtoGrupo/search?searchTerm=${filter.filters.nome.value}&sort=nome,${sortable}`);
                setTotalRecords(respElements.data.totalElements);

            }
        }
        catch (error) {
            if (filter != undefined) {
                if (event == undefined) {
                    const response = await api.get(`produtoGrupo?sort=nome,${sortable}`);
                    response.data.content.map(produto => {
                        setProdutos(produtos => [...produtos, produto])
                    })
                } else {
                    const response = await api.get(`produtoGrupo?page=${event.page}&sort=nome,${sortable}`);
                    response.data.content.map(produto => {
                        setProdutos(produtos => [...produtos, produto])
                    })

                }

                const respElements = await api.get(`produtoGrupo?sort=id,${sortable}`);
                setTotalRecords(respElements.data.totalElements);
            } else {
                toast.current.show({ severity: 'error', summary: 'Erro ao obter produto', detail: error.toString() });
            }
        }

        setIsLoading(false)
    }


    const actionBodyTemplate = (rowData) => {
        const hasEditPermission = permissions_check("produtoGrupo", "editar", permissoes);
        const hasDeletePermission = permissions_check("produtoGrupo", "deletar", permissoes);

        if (!hasEditPermission && !hasDeletePermission) {
            // setShowActionsColumn(false);

            return <div className="actions">
                <Button icon="pi pi-print" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handlePrintClick(rowData)} />
            </div> // No actions to show
        }

        // if (!hasEditPermission && !hasDeletePermission) {
        //     setShowActionsColumn(false);
        //     return null; // No actions to show
        // }

        return (
            <div className="actions">
                <Button icon="pi pi-print" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handlePrintClick(rowData)} />
                <PermissaoLoader rota="produtoGrupo" acao="editar" onClick={() => handleEditClick(rowData)} />
                <PermissaoLoader rota="produtoGrupo" acao="deletar" loading={isDeleting} onClick={() => handleDeleteClick(rowData)} />
            </div>
        );
    }

    const nomeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nome</span>
                    <span className="table-data">{rowData.nome}</span>
                </p>
            </React.Fragment>
        );
    }
    const unPadraoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Un Padrão</span>
                    <span className="table-data">{rowData.unPadrao}</span>
                </p>
            </React.Fragment>
        );
    }

    // const pesoBodyTemplate = (rowData) => {
    //     return (
    //         <React.Fragment>
    //             <p style={{ textalign: 'left' }}>
    //                 <span className="p-column-title">Peso em Kg</span>
    //                 <span className="table-data">{rowData.pesoEmKg}</span>
    //             </p>
    //         </React.Fragment>
    //     );
    // }

    const onSort = (event) => {
        // console.log(event);

        if (sortable == 'asc') {
            setSortable('desc')
        } else if (sortable == 'desc') {
            setSortable('asc')
        }
        // setLazyParams(event);
        setFilter(event);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        // setLazyParams(event);
        setFilter(event);
    }

    const handleEditClick = (data) => {

        history.push(`/produtoGrupo/edit/${data.id}`);

    }

    const handleDeleteClick = (data) => {

        data['userEmail'] = user.email

        confirmDialog({
            message: `Você tem certeza que quer remover ${data.nome}?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {

                    const response = await api.delete(`produtoGrupo/${data.id}`);

                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `${data.nome} removido(a) com sucesso` });
                    getProduto()
                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover o produto', detail: error.response.data });
                }

                setIsDeleting(false);
            },
            reject: () => { return }
        });
    }




    const handlePrintClick = (data) => {        

        api.get(`/produtoGrupo/grupoId/${data.id}`).then((response) => {

            setBoletimPrint(response.data);
        })

        setTimeout(() => {
            setShowPrintBoletim(true);
        }, 1000)


    }



    return (
        <>
            <Dialog className='p-scrollpanel-bar-y' header="Histórico" onHide={() => setIsShowInfo(false)} visible={isShowInfo} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '50vw', heigth: '5vw' }} >
                {msgInfo.map((item) => {
                    return (<p><li>{new Date(item.created_at).toLocaleString()} - {item.log}</li></p>)
                })}
            </Dialog>

            <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">


                <DialogPrintBoletimPorGrupo
                    visible={showPrintBoletim}
                    setVisible={setShowPrintBoletim}
                    setBoletins={setBoletimPrint}
                    boletins={boletimPrint}
                />

                <div className="p-my-0 p-dir-rev p-col">
                    <div className="p-my-0">
                        <Button
                            textalign="center"
                            icon="pi pi-print"
                            className="p-button-secondary"
                            style={{ width: '35px' }}
                            onClick={handlePrintClick}
                            tooltip="Gerar relatório"
                            tooltipOptions={{ position: 'top' }}
                        />
                    </div>
                </div>


                <Toast ref={toast} position="bottom-right" />

                <Toast ref={confirmationToast} position="bottom-center" />

                <div className="card p-col-12 datatable-responsive-demo">

                    <div className="p-fluid">


                        <DataTable

                            totalRecords={totalRecords}
                            lazy="true"
                            first={first}
                            onPage={getProduto}
                            ref={(element) => setDt(element)}
                            header={header}
                            value={produtos}
                            filterDisplay="row"
                            className="p-datatable-responsive-demo"
                            emptyMessage="Nenhum grupo de produto encontrado"
                            loading={isLoading}
                            dataKey="id"
                            paginator
                            rows={20}
                            currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} grupo de produtos`}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                            // rowsPerPageOptions={[10, 20, 30]}
                            onSort={onSort}
                            onFilter={onFilter}
                            filters={filter.filters}

                        >

                            <Column
                                field="nome"
                                header="Nome do Produto"
                                sortable
                                body={nomeBodyTemplate}
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder={filter.filters != undefined && (filter.filters.nome != undefined && filter.filters.nome.value != '') ? filter.filters.nome.value : "Pesquisar pelo produto"}

                            />
                            <Column
                                field="unPadrao"
                                header="Un Padrão"
                                // sortable
                                body={unPadraoBodyTemplate}
                            // filter
                            // filterMatchMode="contains"
                            // filterPlaceholder="Pesquisar pela embalagem"

                            />

                            {showActionsColumn && (
                                <Column
                                    header="Ações"
                                    body={actionBodyTemplate}

                                />
                            )}

                        </DataTable>

                    </div>
                </div>
            </div>

        </>
    );
}
